<script setup lang="ts">
</script>

<template>
  <img
    src="https://res.cloudinary.com/mogelijk/image/upload/v1712140773/site-assets/Logo_Mogelijk_Loader_ilq4a2.png"
    alt="Mogelijk loader"
    class="size-full"
  />
</template>
